/* Product gallery: thumbnail navigation, lightbox zoom */
(function () {
  'use strict';

  var gallery = document.getElementById('product-gallery');
  if (!gallery) return;

  var slides = gallery.querySelectorAll('.product-gallery__slide');
  var thumbs = gallery.querySelectorAll('.product-gallery__thumb');
  var currentIndex = 0;

  function goToSlide(index) {
    slides.forEach(function (s) { s.classList.remove('is-active'); });
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });

    if (slides[index]) slides[index].classList.add('is-active');
    if (thumbs[index]) thumbs[index].classList.add('is-active');
    currentIndex = index;
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var idx = parseInt(thumb.dataset.thumbIndex, 10);
      goToSlide(idx);
    });
  });

  // Touch swipe for mobile
  var touchStartX = 0;
  var mainGallery = document.getElementById('gallery-main');

  mainGallery?.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });

  mainGallery?.addEventListener('touchend', function (e) {
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0 && currentIndex < slides.length - 1) {
        goToSlide(currentIndex + 1);
      } else if (diff < 0 && currentIndex > 0) {
        goToSlide(currentIndex - 1);
      }
    }
  }, { passive: true });

  // Lightbox
  gallery.querySelectorAll('[data-zoom]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var slide = btn.closest('.product-gallery__slide');
      var img = slide?.querySelector('.product-gallery__img');
      var src = img?.dataset.zoomSrc || img?.src;
      if (!src) return;
      openLightbox(src);
    });
  });

  // Click on image to zoom
  slides.forEach(function (slide) {
    var img = slide.querySelector('.product-gallery__img');
    img?.addEventListener('click', function () {
      var src = img.dataset.zoomSrc || img.src;
      openLightbox(src);
    });
  });

  function openLightbox(src) {
    var lb = document.createElement('div');
    lb.className = 'lightbox';
    lb.innerHTML =
      '<button class="lightbox__close" aria-label="Fechar">' +
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<img class="lightbox__img" src="' + src + '" alt="">';

    document.body.appendChild(lb);
    requestAnimationFrame(function () { lb.classList.add('is-active'); });
    document.body.style.overflow = 'hidden';

    function closeLightbox() {
      lb.classList.remove('is-active');
      document.body.style.overflow = '';
      setTimeout(function () { lb.remove(); }, 300);
    }

    lb.querySelector('.lightbox__close').addEventListener('click', closeLightbox);
    lb.addEventListener('click', function (e) {
      if (e.target === lb) closeLightbox();
    });

    document.addEventListener('keydown', function handler(e) {
      if (e.key === 'Escape') {
        closeLightbox();
        document.removeEventListener('keydown', handler);
      }
    });
  }
})();
